import { SlideFrame, SlideHeader, Reveal } from "@/components/presentation/slides/SlideFrame";
import { Timeline } from "@/components/primitives/Timeline";
import { ProgressIndicator } from "@/components/primitives/ProgressIndicator";

const DEFAULT_MILESTONES = [
  { id: "m1", date: "Q1 · Y1", title: "Foundational milestone",  body: "Placeholder copy.", active: false },
  { id: "m2", date: "Q3 · Y1", title: "Expansion milestone",     body: "Placeholder copy.", active: false },
  { id: "m3", date: "Q1 · Y2", title: "Current focus",           body: "Placeholder copy.", active: true  },
  { id: "m4", date: "Q3 · Y2", title: "Next milestone",          body: "Placeholder copy." },
  { id: "m5", date: "Q1 · Y3", title: "Future milestone",        body: "Placeholder copy." },
];

/**
 * 07 · TimelineSlide
 *
 * Vertical timeline with a quiet progress rail above it. The progress value
 * defaults to the index of the active milestone, but can be passed in
 * explicitly for finer control.
 */
export const TimelineSlide = ({
  eyebrow = "Roadmap",
  title = "Where we have been, and where we are going.",
  narrative = "A short overview of the arc, said calmly. The timeline carries the rest.",
  milestones = DEFAULT_MILESTONES,
  progress,
  progressLabel = "Plan progress",
}) => {
  const activeIndex = Math.max(0, milestones.findIndex((m) => m.active));
  const computedProgress =
    progress != null
      ? progress
      : ((activeIndex + 1) / Math.max(1, milestones.length)) * 100;

  return (
    <SlideFrame testId="slide-timeline">
      <SlideHeader eyebrow={eyebrow} title={title} lede={narrative} />
      <Reveal delay={2}>
        <div className="mx-auto w-full max-w-md" data-testid="timeline-progress">
          <ProgressIndicator value={computedProgress} label={progressLabel} />
        </div>
      </Reveal>
      <Reveal delay={3}>
        <Timeline items={milestones} testId="timeline-list" />
      </Reveal>
    </SlideFrame>
  );
};

export default TimelineSlide;
